import { useQuery } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { HEALTH_PATH } from '@mcikm-vote/shared';
import type { HealthResponse } from '@mcikm-vote/shared';

async function ladeHealth(): Promise<HealthResponse> {
  const antwort = await fetch(HEALTH_PATH, { headers: { Accept: 'application/json' } });
  if (!antwort.ok && antwort.status !== 503) {
    throw new Error('Der Serverstatus konnte nicht abgerufen werden.');
  }
  return (await antwort.json()) as HealthResponse;
}

/**
 * Zeigt den Serverstatus an.
 *
 * In Stufe S0 dient dies dem Nachweis, dass Frontend und Backend zusammenspielen. Der
 * ausführliche Systemstatus nach §20.4 entsteht in Stufe S8 im Administrationsbereich.
 */
export function SystemStatus(): ReactElement {
  const { data, isPending, isError } = useQuery({
    queryKey: ['system', 'health'],
    queryFn: ladeHealth,
    // Regelmäßige Abfrage als Rückfalllösung; Socket.IO folgt in Stufe S5 (§22.2).
    refetchInterval: 30_000,
  });

  if (isPending) {
    return <p className="text-text-gedaempft text-sm">Serverstatus wird abgerufen …</p>;
  }

  if (isError || data === undefined) {
    return (
      <p className="text-fehler text-sm font-medium">
        Keine Verbindung zum Server. Bitte Verbindung prüfen.
      </p>
    );
  }

  const inOrdnung = data.status === 'ok';

  return (
    <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
      <dt className="text-text-gedaempft">Status</dt>
      <dd className={inOrdnung ? 'text-erfolg font-medium' : 'text-fehler font-medium'}>
        {inOrdnung ? 'betriebsbereit' : 'gestört'}
      </dd>

      <dt className="text-text-gedaempft">Version</dt>
      <dd>{data.version}</dd>

      <dt className="text-text-gedaempft">Betriebsmodus</dt>
      <dd>{data.betriebsmodus}</dd>
    </dl>
  );
}
